'use client';

import { motion } from 'framer-motion';

export function TestimonialsSection() {
  const testimonials = [
    {
      quote: 'The attention to detail and innovative features have completely transformed our workflow. This is exactly what we\'ve been looking for.',
      name: 'Sarah Chen',
      designation: 'Product Manager at TechFlow',
      image: '👩‍💼',
    },
    {
      quote: 'Implementation was seamless and the results exceeded our expectations. The platform\'s flexibility is remarkable.',
      name: 'Michael Rodriguez',
      designation: 'CTO at InnovateSphere',
      image: '👨‍💻',
    },
    {
      quote: 'This solution has significantly improved our team\'s productivity. The intuitive interface makes complex tasks simple.',
      name: 'Emily Watson',
      designation: 'Operations Director at CloudScale',
      image: '👩‍💼',
    },
    {
      quote: 'Outstanding support and robust features. It\'s rare to find a product that delivers on all its promises.',
      name: 'James Kim',
      designation: 'Engineering Lead at DataPro',
      image: '👨‍🔬',
    },
    {
      quote: 'The scalability and performance have been game-changing for our organization. Highly recommend to any growing business.',
      name: 'Lisa Thompson',
      designation: 'VP of Technology at FutureNet',
      image: '👩‍💼',
    },
  ];

  return (
    <section className="relative w-full bg-gradient-to-b from-slate-50 to-white px-4 py-20 dark:from-slate-900 dark:to-slate-950 md:py-32">
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-4 text-4xl font-bold text-slate-900 dark:text-white md:text-5xl">
            Trusted by Teams Worldwide
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-slate-600 dark:text-slate-400">
            See what industry leaders are saying about their experience with our platform
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-2 hover:border-blue-500 hover:shadow-xl dark:border-slate-700 dark:bg-slate-800 dark:hover:border-blue-500"
            >
              <div className="absolute -inset-0.5 rounded-xl bg-gradient-to-r from-blue-500 to-purple-500 opacity-0 blur-xl transition-all duration-500 group-hover:opacity-20" />
              <div className="relative">
                <p className="mb-6 text-base italic text-slate-600 dark:text-slate-300">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100 text-xl dark:bg-blue-900">
                    {testimonial.image}
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900 dark:text-white">{testimonial.name}</p>
                    <p className="text-sm text-slate-500 dark:text-slate-400">{testimonial.designation}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
